export default __webpack_public_path__ + "static/media/tableaulogo.802f8cc9.png";